import Skeleton from '../presentational/skeleton';

export default function SkeletonProfileWarningSmall(props: any) {
	return (
		<section className="rio-hidden--x-small rio-hidden--x-large rio-hidden--large text-white slds-m-bottom--small">
			<div className="slds-grid slds-wrap">
				{props.isFullProfile && (
					<div className="slds-size--1-of-1 slds-p-around--small">
						<Skeleton height={40} animate />
					</div>
				)}
				<div className="slds-grid slds-size--1-of-1 slds-grid--align-center">
					<Skeleton width={130} height={40} style={{ borderRadius: '4px', margin: 12 }} animate />
				</div>
				<div className="slds-grid slds-size--1-of-1 slds-grid--align-center">
					<Skeleton width={158} height={20} style={{ borderRadius: '4px' }} animate />
				</div>
			</div>
		</section>
	)
}
